(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dear-privacy"] && !Shopify.designMode) return;
  try {
    (() => {
  let attempts = 0;
  const exposePreferences = () => {
    if (typeof window.privacyBanner?.showPreferences !== 'function') return false;
    document.querySelectorAll('.dp-cookie-settings').forEach(button => { button.hidden = false; });
    return true;
  };
  if (!exposePreferences()) {
    const timer = setInterval(() => {
      if (exposePreferences() || ++attempts >= 40) clearInterval(timer);
    }, 250);
  }
  document.addEventListener('shopify:section:load', exposePreferences);
  document.addEventListener('click', event => {
    const button = event.target.closest('.dp-cookie-settings');
    if (!button || typeof window.privacyBanner?.showPreferences !== 'function') return;
    window.privacyBanner.showPreferences().catch(() => { button.hidden = true; });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
